export default [{
  name: 'normal',
  value: 400
}, {
  name: 'bold',
  value: 600
}];